import React from 'react';
import styles from './styles.module.scss';

interface SkeletoneProps {
  className?: string;
  variant?: 'light' | 'dark';
  divider?: boolean;
}

const Skeletone: React.FC<SkeletoneProps> = ({
  className = '',
  variant = 'light',
  divider = false,
}) => {
  return (
    <div
      style={{ borderRight: divider ? '2px solid #e0e0e0' : 'none' }}
      className={`${styles.SkeletoneWrapper} ${className} ${styles[variant]}`}
    >
      <div className={styles.walletIcon}>
        <div className={`${styles.circle} ${styles.shimmer}`} />
      </div>
      <div className={styles.main}>
        <div className="w-100">
          <div className={styles.balance}>
            <div>
              <div className={`${styles.label} ${styles.shimmer}`} />
              <div className={`${styles.value} ${styles.shimmer}`} />
            </div>
          </div>
          <div className={`${styles.transaction} ${styles.shimmer}`} />
        </div>
        <div className={`${styles.button} ${styles.shimmer}`} />
      </div>
    </div>
  );
};

export default Skeletone;
